import classed from "classed-components"

export const Input =
    classed.input(`px-2 py-1 my-1 text-light login-input`)
